import SkillsDesktop from "./SkillsDesktop";

export default SkillsDesktop;
export { SkillsDesktop };
